<script>
  import options from './ListItem.options'
  const componentOptions = options
  export default componentOptions
</script>

<template>
  <article class="be-list-item">
    <a :href="result.url" class="be-list-item__wrapper" :class="{'be-list-item__wrapper--pills': result?.pills?.length > 0}">
      <div class="be-list-item__content">
        <div class="be-list-item__content-header">
          <h3 class="be-list-item__content-header-title">{{ result.title }}</h3>
          <span class="be-list-item__content-header-arrow">
            <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32"><path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M26.333 15.634h-20M18.267 7.602l8.067 8.032-8.067 8.033"/></svg>
          </span>
        </div>
        <p class="be-list-item__content-description">{{ result.summary }}</p>

        <template v-if="result?.pills?.length > 0"> 
          <ul class="be-filter-concept__tags" aria-live="polite">
            <li v-for="pill, index in result.pills" :key="index">
              <p class="be-pill">
                <span class="be-pill-name">{{ pill }}</span>
              </p>
            </li>
          </ul>
        </template>

        <template v-if="(result?.tags || result?.date) && !(result?.pills?.length > 0)">
          <p class="be-list-item__content-meta">
            <span v-if="result?.tags" class="be-list-item__content-meta-label">
              <span v-for="tag, index in result.tags" :key="index">{{ tag }}</span>
            </span>
            <span v-if="result?.date" class="be-list-item__content-meta-date"><time>{{ result.date }}</time></span>
          </p>
        </template>

        <template v-if="(result?.date || result?.deadline) && (result?.pills?.length > 0)"> 
          <div class="be-list-item__content-job-post">
            <p v-if="result?.date" class="be-list-item__content-meta-date"><time>{{ result.date }}</time></p>
            <p v-if="result?.deadline" class="be-list-item__content-meta-deadline"><time>{{ result.deadline }}</time></p>
          </div>
        </template>

      </div>
      <div v-if="result?.imageUrl || result?.icon" class="be-list-item__image-wrapper">
        <template v-if="result?.imageUrl">
          <img :src="result.imageUrl" :alt="result.imageAltText ?? ''" />
        </template>
        <template v-if="result?.icon">
          <span v-html="result.icon"></span>
          <p v-if="result?.imageAltText" class="be-visually-hidden">{{ result.imageAltText }}</p>
        </template>
      </div>
    </a>

    <hr class="be-list-item__divider" />
  </article>
</template>
